import React, { useState, useRef, useEffect } from "react"
import { components } from "react-select"

const { DownChevron } = components

export const CourseHeaderDropdownButton = ({ url, onClick, text, extraStyling, items, onSelect }) => {
  const [showDropdown, setShowDropdown] = useState(false)
  const [buttonMinWidth, setButtonMinWidth] = useState(null)
  const containerRef = useRef(null)
  const dropdownMenuRef = useRef(null)

  useEffect(() => {
    if (dropdownMenuRef.current) {
      setButtonMinWidth(dropdownMenuRef.current.offsetWidth)
    }
  }, [])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowDropdown(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const handleButtonClick = (e) => {
    e.preventDefault()
    if (items?.length) {
      setShowDropdown((prev) => !prev)
    } else if (onClick) {
      onClick(e)
    }
  }

  const handleItemSelect = (source) => {
    setShowDropdown(false)
    onSelect?.(source)
  }

  return (
    <div ref={containerRef} className={['course-buttons-dropdown-container', extraStyling].filter(Boolean).join(' ')}>
      <a href={url} onClick={handleButtonClick} className="remove_outline_for_a">
        <div className="btsp_bullet_button btn_inline btsp_bullet_button set_outline_for_button course-buttons-dropdown-button" style={buttonMinWidth ? { minWidth: buttonMinWidth } : undefined}>
          <div className="icon">
            <i className="gga-circle-plus" />
          </div>
          <div className="btsp_align-middle">
            {text}
          </div>
          <div className="btsp_align-middle dropdown-button-chevron pull-right" style={{ marginLeft: 'auto' }}>
            <DownChevron />
          </div>
        </div>
      </a>
      {items?.length > 0 && (
        <ul
          ref={dropdownMenuRef}
          className="dropdown-menu course-buttons-dropdown-menu"
          style={!showDropdown ? { visibility: 'hidden', pointerEvents: 'none', position: 'absolute' } : undefined}
        >
          {items.map(({ source, label }) => (
            <li key={source}>
              <a href="#" onClick={(e) => { e.preventDefault(); handleItemSelect(source) }}>
                {label}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
